module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"emptyErrorMessage":"Feld darf nicht leer sein","tooShortErrorMessage":"Kürzer als {minLength}","tooLongErrorMessage":"Länger als {maxLength}"}}')
  delete Component.options._Ctor
}
